import React, { useState } from "react";

import { Link } from "react-router-dom";

import { getCookie } from "../utility/Cookie";

const Settings = () => {
  const [user] = useState(JSON.parse(getCookie("_g_")));

  return (
    <div className="settings-page">
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <div className="settings-header">
              <div className="user-after">
                <i className="fas fa-user-alt"></i>
              </div>
              <h6>
                {user?.first_name} {user?.last_name}
              </h6>
              <p>{user?.email}</p>
              <div className="settings-edit">
                <Link className="settings-edit-item" to="/settings-info-edit">
                  Edit your information
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
